import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CMS_COMPONENT_CWV_CONFIG } from '../../../../catalog/config/component.config';
import { NCmsBlogComponentImageWithOverlappingCopy } from './cms-blog-component-image-with-overlapping-copy.interface';

export const CMS_BLOG_COMPONENT_IMAGE_WITH_OVERLAPPING_COPY = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsBlogComponentImageWithOverlappingCopy.ID,
    name: 'Image with overlapping bottom copy',
    tags: ['blog'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'component_width',
            type: NICmsContentField.EFieldType.choice,
            title: 'Width',
            default: 'full',
            options: [
                { key: 'full', title: 'Full Width (wrap)' },
                { key: 'fixed', title: 'Fixed Width' }
            ]
        },
        {
            type: NICmsContentField.EFieldType.textarea,
            key: 'copy',
            title: 'Top section copy'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Main image'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'url',
            title: 'Link',
            default: '/'
        },
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
